exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul#news-list li[data-v-5b314ae0]{cursor:pointer}", ""]);

// exports
